"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveLau = void 0;
const Storage_1 = require("../../Storage");
const react_1 = require("react");
const AuthProvider_1 = require("../providers/AuthProvider");
const useActiveLau = () => {
    const activeLau = (0, AuthProvider_1.useAuthSelector)(state => state.activeLau);
    const [getStoredLau, saveLau] = (0, Storage_1.useStorage)("lau");
    const dispatch = (0, AuthProvider_1.useAuthDispatch)();
    const setActiveLau = (lau) => {
        saveLau(lau);
        dispatch(AuthProvider_1.AuthAction.setActiveLau(lau));
    };
    (0, react_1.useEffect)(() => {
        const storeLau = getStoredLau();
        if (storeLau)
            setActiveLau(storeLau);
    }, []);
    const unsetActiveLau = () => {
        setActiveLau(undefined);
    };
    return {
        activeLau,
        setActiveLau,
        unsetActiveLau
    };
};
exports.useActiveLau = useActiveLau;
